import React from 'react';
import {HelmetWrapper, basicHelmetGenerator} from 'utility/DefaultMeta';
import { Row, Col } from '@zendeskgarden/react-grid';
import { XXL, LG, MD} from '@zendeskgarden/react-typography';
import RfShieldingHero from './components/RfShieldingHero/RfShieldingHero';
import RfShieldingSolutions from './components/RfShieldingSolutions/RfShieldingSolutions';
import CopperShielding from './components/CopperShielding/CopperShielding';
import SteelPannelShielding from './components/SteelPannelShielding/SteelPannelShielding';

import {trackClick} from 'utility/analytics';
import PageViewWrapper from 'higherOrder/PageViewWrapper';
import {openModal} from 'state/modals/actions';
import {Button} from 'theme/Button';
import {
  CompanyPage,
  InlineSection,
  LandingSectionInner
} from './RfShielding.styles';

import {
  LandingSection,
} from 'theme/Page';


import { variables } from 'theme/variables';

const {
  custom_light_grey,
} = variables;


const RfShielding = (props) => {
  function goTorequest() {
    trackClick('inquire', 'Submit RFQ', 'RfShielding');
    openModal({
      type: 'inquireFormModal'
    })
  }


  return (
    <CompanyPage>
        <HelmetWrapper metadata={basicHelmetGenerator({
          title:'RF Shielding - Magnetic Resonance Technologies',
          description: '',
        })} />

        <LandingSection colStyle={{position: 'unset'}} style={{paddingBottom: 0}}>
          <LandingSectionInner>
            <RfShieldingHero />
          </LandingSectionInner>
        </LandingSection>
        
        <LandingSection skewed style={{padding: '50px 10px'}}>
          <LandingSectionInner>
            <RfShieldingSolutions />
          </LandingSectionInner>
        </LandingSection>

        <LandingSection style={{padding: '50px 10px'}}>
          <LandingSectionInner>
            <CopperShielding />
          </LandingSectionInner>
        </LandingSection>

        <LandingSection skewed style={{padding: '50px 10px'}}>
          <LandingSectionInner>
            <SteelPannelShielding />
          </LandingSectionInner>
        </LandingSection>

 


        <InlineSection style={{paddingTop: 0, marginBottom: 0}}>
          <LandingSection>
            <div style={{maxWidth: '999px', margin: '0 auto', padding: '40px 0'}}>
              <Row alignCenter>
                <Col size={12} justifyCenter column>
                  <MD center blue uppercase paddingBottomLg semibold>Submit a Request</MD>
                  <XXL center bold>Work With Us On Your Next Project</XXL>
                  <LG style={{maxWidth: '750px', margin: '0 auto'}} center scaled slate paddingTopLg paddingBottomLg light>
                    Leading the Industry in Buying & Selling Medical Eqipment, RF Shield Quality, Assurance Testing, and Maintenance Programs.
                  </LG>
                  <Row style={{margin: '0 auto', marginTop: '30px'}}>
                    <Col size={12} sm="auto">
                      <Button onClick={goTorequest} pairButton size="large" spacingBottom primary>Submit A Request</Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </LandingSection>
        </InlineSection>
        
    </CompanyPage>
  )
}


export default PageViewWrapper(RfShielding, {pageName: 'RfShielding'})
